import { h, ComponentChildren } from 'preact';

interface OutlinedButtonProps {
  onClick?: (e: Event) => void;
  class?: string;
  children: ComponentChildren;
}

/**
 * Outlined button in accent blue. Fills solid on hover.
 */
export function OutlinedButton({ onClick, class: className, children }: OutlinedButtonProps) {
  return (
    <button class={`btn-outlined${className ? ` ${className}` : ''}`} onClick={onClick}>
      {children}
    </button>
  );
}
